import React, { useEffect } from 'react';
import { Steps, Icon } from 'antd';
import { Widget } from '@digital/ui';
import { StepsTimeline } from '@app/api/status';
import { formatarDataPadrao } from '@app/helpers/dateTimeFormats';
import {
  stepState, ordemCompraIdState, fluxoProcessoState, proxStepState, anteriorStepState,
  ordemCompraRodadaNegociacaoIdState,
  reloadWidgetTimelineState,
  reloadVendorListState,
  reloadAnexosState,
  allStepsState,
  ajustarStepOnReloadState,
  reloadDadosGeraisState
} from '../atoms';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import './../custom.css';
import { Visibility } from '@app/components';
import { EStatusEtapaFluxoProcesso } from '@app/enums/EStatusEtapaFluxoProcesso';
import { isObjEmpty, isObjNotEmpty } from '@app/helpers/objHelper';
import { avancarOrdemCompra } from '@app/api/sas/ordemCompra';
import { EGuidFluxoProcessoEtapa } from '@app/enums/EGuidFluxoProcessoEtapa';

interface Props {
  executeScroll: () => any;
}

const WidgetTimeline = ({ executeScroll }: Props) => {

  const steps = useRecoilValue<StepsTimeline[]>(allStepsState);

  const ordemCompraId = useRecoilValue(ordemCompraIdState);
  const fluxoId = useRecoilValue(fluxoProcessoState);
  const ordemCompraRodadaNegociacaoId = useRecoilValue(ordemCompraRodadaNegociacaoIdState);

  const setProxStep = useSetRecoilState(proxStepState);
  const setAnteriorStep = useSetRecoilState(anteriorStepState);
  const setOrdemCompraRodadaNegociacaoIdId = useSetRecoilState(ordemCompraRodadaNegociacaoIdState);
  const setAjustarStepOnReload = useSetRecoilState(ajustarStepOnReloadState);

  const [step, setStep] = useRecoilState<StepsTimeline>(stepState);
  const [reloadWidgetTimeline, setReloadWidgetTimeline] = useRecoilState(reloadWidgetTimelineState);
  const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);
  const [reloadAnexos, setReloadAnexos] = useRecoilState(reloadAnexosState);
  const [reloadDadosGerais, setReloadDadosGerais] = useRecoilState(reloadDadosGeraisState);

  useEffect(() => {
    if (fluxoId && steps.length > 0 && isObjEmpty(step)) {
      let indexStep = steps.map((item: StepsTimeline) => item.fluxoEtapaId).lastIndexOf(fluxoId);
      clickItem(steps[indexStep]);
    }
  }, [fluxoId, steps]);

  useEffect(() => {
    if (steps.length > 0 && isObjNotEmpty(step)) {
      let indexStep = steps.findIndex(item => item.ordem === step.ordem);
      let indexAnterior = definirStepAnterior(indexStep - 1);
      let indexProx = definirStepProx(indexStep + 1);

      const stepsTmp = steps.filter(f => f.status != '');
      setAnteriorStep(stepsTmp[indexAnterior]);
      setProxStep(stepsTmp[indexProx]);
      // console.log('index', indexAnterior, indexStep, indexProx);
    }
  }, [step, steps]);

  useEffect(() => {
    clickItem(step);
  }, [step]);

  useEffect(() => {
    if (!ordemCompraId || isObjEmpty(step)) return;

    //atualizar as ações com o PreEtapa antes de att o vendor list
    avancarOrdemCompra(ordemCompraId, {
      ordemCompraRodadaNegociacaoId: step.ordemCompraRodadaNegociacaoId,
      fluxoProcessoId: step.fluxoEtapaId,
      pularProximaEtapa: true,
    }, false)
      .then((res: any) => {
        // if (res.reloadPage === true) {
        //   window.location.reload();
        //   return;
        // }

        //perigo de loop infinito
        if (res.reloadTimeline === true) {
          setReloadDadosGerais(!reloadDadosGerais);
          setAjustarStepOnReload(false);
          setReloadWidgetTimeline(!reloadWidgetTimeline);
        }

        if (res.reloadAnexos === true) {
          setReloadAnexos(!reloadAnexos);
        }
      })
      .finally(() => setReloadVendorList(!reloadVendorList));
  }, [step]);

  const clickItem = (clickItem: StepsTimeline) => {
    setAjustarStepOnReload(false);
    executeScroll();

    if (!step || isObjEmpty(step)) return;

    if (clickItem && clickItem.status && clickItem.status != '' && clickItem.status !== 'Não Aplicável') {
      if (clickItem.ordem != step.ordem) {
        const stpTemp = steps.find(step => step.ordem === clickItem.ordem) || {} as StepsTimeline;
        if (isObjNotEmpty(stpTemp)) {
          setStep(stpTemp);
        }
      }
      setOrdemCompraRodadaNegociacaoIdId(clickItem.ordemCompraRodadaNegociacaoId);
    }
  };

  const definirStepAnterior = (index: number): number => {
    let step = steps[index];
    if (!step) return index;
    if ((isObjNotEmpty(step.statusEtapaFluxoProcessoId) && step.statusEtapaFluxoProcessoId != EStatusEtapaFluxoProcesso.NaoAplicavel.id)
      && (step.status && step.status !== '')
    ) {
      return index;
    }
    return definirStepAnterior(index - 1);
  };

  const definirStepProx = (index: number): number => {
    while (index < steps.length) {
      let proxStep = steps[index];
      let ehStatusDiferenteVazio = 'status' in proxStep && proxStep.status !== "";
      let ehStatusDiferenteNA = 'status' in proxStep && proxStep.status !== 'Não Aplicável';
      let ehstatusEtapaFluxoProcessoDiferenteNA = 'statusEtapaFluxoProcessoId' in proxStep && proxStep.statusEtapaFluxoProcessoId !== EStatusEtapaFluxoProcesso.NaoAplicavel.id;

      if (ehStatusDiferenteVazio && (ehStatusDiferenteNA || ehstatusEtapaFluxoProcessoDiferenteNA)) {
        return index;
      }
      index++;
    }

    var idx = steps.findIndex(f => f.status !== "Não Aplicável");
    if (idx) return idx;

    return (steps.length - 1);
  };

  const definirStatus = (item: StepsTimeline): 'wait' | 'process' | 'finish' | 'error' | undefined => {
    let status: 'wait' | 'process' | 'finish' | 'error' | undefined = undefined;
    if (item.status && ['Não Aplicável'].includes(item.status)) status = "wait";
    if (item.status && item.status === 'Concluído') status = "finish";
    if (item.status && item.status === 'Obrigatório') status = "error";
    if (item.ordem === step.ordem) status = "process";
    return status;
  };

  return (
    <Widget title="Timeline">
      <Visibility visible={isObjNotEmpty(steps)} >
        <Steps
          initial={0}
          size="small"
          style={{ width: "100%", overflowWrap: "break-word" }}
          direction="vertical"
          current={steps.indexOf(step)}
        >
          {step && steps.map((item: StepsTimeline, index) => {
            let classN = '';
            if (item.status && item.status != '' && item.status !== 'Não Aplicável') classN += ' clicavel ';
            if (item.isPendente) classN += ' pendente ';
            return (
              <Steps.Step
                status={definirStatus(item)}
                className={classN}
                key={item.ordem}
                title={item.nome}
                onClick={() => { clickItem(item); }}
                description={`${item.status} ${item.dataRealConclusao ? ": " + formatarDataPadrao(item.dataRealConclusao) : ""}`}
                icon={item.isPendente ? <Icon type="warning" style={{ color: '#ffc107' }} /> : undefined}
              />
            );
          })}
        </Steps>
      </Visibility>
    </Widget>
  );
};

export default WidgetTimeline;
